import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CircleRightTop from "../images/EllipseTeamTopLeft.png";
import CircleLeftBottom from "../images/EllipseRightBottom.png";
import arrow_btn from "../images/arrow_btn.svg";
import empowerImage from "../images/empower-image.svg";
import { useTranslation } from "react-i18next";

const HomePageMain = ({ isWideScreen, isMobileScreen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href =
      "https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap";
    document.head.appendChild(fontLink);

    // Clean up the added link when the component is unmounted
    return () => {
      document.head.removeChild(fontLink);
    };
  }, []);

  const highlightedGradientText = (text) => {
    return (
      <span className="text-[30px] sm:text-[40px] leading-[45px] sm:leading-[50px] md:leading-[60px] 3xl:leading-[102px] md:text-[60px] 3xl:text-[80px] font-[700] bg-gradient-to-r from-blue-600 via-purple-600 to-purple-900 text-transparent bg-clip-text capitalize">
        {text}
      </span>
    );
  };

  const highlightedText = (text, subTitle) => {
    return isMobileScreen ? (
      <span
        className={`${
          subTitle === "unify"
            ? `sm:text-[28px]`
            : `text-[30px] sm:text-[34px] md:text-[36px]`
        }   3xl:text-[51px] leading-[45px] sm:leading-[50px] md:leading-[58px] 3xl:leading-[80px]  font-[700] text-primaryButtonTextColor capitalize`}
      >
        {text}
      </span>
    ) : (
      text
    );
  };

  return (
    <div className="login__section min-h-[450px] 2xl:min-h-[800px]">
      <img
        draggable="false"
        src={CircleRightTop}
        className="back_circle1"
        alt="back_circle1"
      />
      <img
        draggable="false"
        src={CircleLeftBottom}
        className="back_circle2"
        alt="back_circle2"
      />
      <div className="container px-2 mt-[60px] sm:mt-[50px] md-[50px] xl:max-w-[1000px] 3xl:max-w-[1400px]">
        <div className="container flex sm:gap-[0%] lg:gap-[0%]  sm:my-[30px] md:my-[40px] lg:my-[40px]">
          <div className="container lg:w-[55%] px-2 mt-[35px] sm:mt-[90px] md-[50px] xl:max-w-[1200px] 3xl:max-w-[1600px]">
            <h1 className="text-[30px] sm:text-[34px] md:text-[36px] leading-[50px] sm:leading-[56px] md:leading-[58px] 3xl:leading-[80px] 3xl:text-[51px]  font-[700] text-[#141619] capitalize">
              {highlightedText(t("empowering"))} {t("your")}{" "}
              {highlightedText(t("compliance"))} {t("journey;")}
            </h1>
            <h1 className="text-[30px] sm:text-[28px] leading-[50px] sm:leading-[56px] md:leading-[58px] 3xl:leading-[80px] 3xl:text-[51px] font-[700] text-[#141619] capitalize hero-subtitle">
              {/* {isMobileScreen ? `$` : `unify data, streamline reporting`} */}
              {highlightedText(t("unify"), "unify")} {t("data")},{" "}
              {highlightedText(t("streamline"), "unify")} {t("reporting")}
            </h1>

            <div className="mt-5">
              <span className="sora text-[#141619] md:text-[14px] lg:text-[13px] xl:text-[13px] text-[16px] sm:text-[16px] 3xl:text-[19px] font-[400]">
                {t("platform_description")}
              </span>
            </div>
            <div className="py-3 lg:pt-11">
              <div
                className="requestDemoBtnOuter"
                onClick={() => navigate("/contact-us")}
              >
                <Button className="requestDemoBtn sora">
                  {t("talk_to_expert")}
                  <img
                    draggable="false"
                    src={arrow_btn}
                    className="w-[9px] sm:w-[12px] ml-[4px]"
                    alt="Arrow_up_small"
                  />
                </Button>
              </div>
            </div>
          </div>
          {isWideScreen ? (
            <div className="flex justify-center lg:w-[45%]">
              <img
                draggable="false"
                src={empowerImage}
                className="h-[350px] w-[400px] lg:h-[480px] md:w-[390px] rounded-[10px] object-contain"
                alt="web3 security"
              />
            </div>
          ) : null}
        </div>
        {/* <div className=""> */}
        {/* <h1 className="text-[30px] sm:text-[40px] leading-[50px] sm:leading-[56px] md:leading-[66px] 3xl:leading-[102px]  md:text-[60px]  3xl:text-[80px]  font-[700] text-[#141619] capitalize">
                        {highlightedText("Empowering")} your {highlightedText("compliance")} journey; {highlightedText("unify")} data,  {highlightedText("streamline")} reporting
                    </h1>
                    <img src={empowerImage} alt="empowerImage" /> */}
        {/* </div> */}

        {/* <div className="border border-[#DADADA] rounded-[30px] w-100 mt-10" style={{ background: "#F3F6FF" }}>
                    <div className="">
                        <div className="py-2 sm:py-6 xl:py-11 px-2 sm:px-3 xl:px-5 2xl:flex flex-col col-span-2" >
                            <TalkToAnExpert />
                        </div>
                        <div className="py-3 px-2 sm:px-3 xl:px-5 2xl:flex flex-col col-span-2 sm:col-span-1 text-center flex justify-center ">
                            <div className=' flex justify-center '>
                                <div className="requestDemoBtnOuter" onClick={() => navigate("/contact-us")}>
                                    <Button className="requestDemoBtn capitalize" >Talk to an Expert<img draggable="false" src={arrow_btn} className="w-[9px] sm:w-[12px] ml-[4px]" alt="Arrow_up_small" /></Button>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div className="sm:grid sm:grid-cols-2 hidden sm:visible sm:pb-6 xl:pb-11">
                        <div className=' flex justify-center'>
                            <div className="requestDemoBtnOuter" onClick={() => navigate("/contact-us")}>
                                <Button className="requestDemoBtn" >Request Demo<img draggable="false" src={arrow_btn} className="w-[9px] sm:w-[12px] ml-[4px]" alt="Arrow_up_small" /></Button>
                            </div>
                        </div> 
                         <div className=' pb-4 sm:pb-0 flex justify-center'>
                            <div className="getStartedBtnOuter" onClick={() =>
                                window.open(LOGIN_PAGE_URL, "_blank")
                            }>
                                <Button className="getStartedBtn" >Join Platform<img draggable="false" src={Arrow_up_small} className="w-[9px] sm:w-[12px] ml-[4px]" alt="Arrow_up_small" /></Button>
                            </div>
                        </div> 
                    </div> 
                </div> */}
      </div>
    </div>
  );
};

export default HomePageMain;
